var pos_data = { id: 0, functions: {} };
var pos_func = {};
var incPosNum = 0;
var iconv = require('iconv-lite');

function getPosData() {
	pos_data.functions = pos_func;
	pos_func = {};
	incPosNum = 0;

	return JSON.stringify(pos_data);
}

function setPosId(setId) {
	pos_data.id = setId;
}

function checkPrinterStatus() {
	var _a = { checkPrinterStatus: [] };
	pos_func['func' + incPosNum] = _a;
	incPosNum++;
}

function directPrintText(text) {
	var _a = { directPrintText: [text] };
	pos_func['func' + incPosNum] = _a;
	incPosNum++;
}

function directPrintHex(hexString) {
	var _a = { directPrintHex: [hexString] };
	pos_func['func' + incPosNum] = _a;
	incPosNum++;
}

function cutPaper(bFeedCut = 0) {
	var _a = { cutPaper: [bFeedCut] };
	pos_func['func' + incPosNum] = _a;
	incPosNum++;
}

function setInternationalCharset(ics) {
	var _a = { setInternationalCharset: [ics] };
	pos_func['func' + incPosNum] = _a;
	incPosNum++;
}

function setCharacterset(charset) {
	var _a = { setCharacterset: [charset] };
	pos_func['func' + incPosNum] = _a;
	incPosNum++;
}

/**
 * Encode for Bixolon printText.
 * Prefer GB2312 (existing PC path), then GBK, then plain Unicode if encode fails.
 */
function encodePrintTextWithFallback(text) {
	var str = text == null ? '' : String(text);
	var encodings = ['gb2312', 'gbk'];

	for (var i = 0; i < encodings.length; i++) {
		try {
			return iconv.encode(str, encodings[i]).toString('binary');
		} catch (e) {
			// try next encoding
		}
	}

	return str;
}

function isAndroidDevice() {
	return (
		typeof navigator !== 'undefined' &&
		/Android/i.test(navigator.userAgent || '')
	);
}

function hasCjk(text) {
	return /[\u3400-\u9FFF\uF900-\uFAFF]/.test(text || '');
}

function toHexBytes(binaryStr) {
	var hex = '';
	for (var i = 0; i < binaryStr.length; i++) {
		var h = (binaryStr.charCodeAt(i) & 0xff).toString(16);
		hex += h.length < 2 ? '0' + h : h;
	}
	return hex.toUpperCase();
}

function padHexByte(n) {
	var h = (n & 0xff).toString(16).toUpperCase();
	return h.length < 2 ? '0' + h : h;
}

/**
 * Android WebPrintSDK UTF-8 JSON corrupts GB2312 inside printText → ????.
 * Send as hex (ASCII-safe) with ESC/POS Chinese character mode.
 * Uses printer device font (not bitmap).
 */
function printAndroidCjkAsText(
	text,
	horizontal,
	vertical,
	bold,
	underline,
	alignment,
) {
	var gb = encodePrintTextWithFallback(text);
	var hex = '';
	hex += '1C4300'; // FS C 0 = GB2312
	hex += '1C26'; // FS & = Chinese character mode on
	hex += '1B61' + padHexByte(alignment || 0); // ESC a n
	hex += bold ? '1B4501' : '1B4500'; // ESC E n
	if (underline) {
		hex += '1B2D01';
	}
	if (horizontal || vertical) {
		hex += '1D21' + padHexByte(((vertical || 0) << 4) | (horizontal || 0));
	}
	hex += toHexBytes(gb);
	hex += '1C2E'; // FS . = Chinese mode off
	directPrintHex(hex);
}

function printText(
	text,
	horizontal,
	vertical,
	bold,
	invert,
	underline,
	fonttype,
	alignment,
) {
	if (isAndroidDevice() && hasCjk(text)) {
		printAndroidCjkAsText(
			text,
			horizontal,
			vertical,
			bold,
			underline,
			alignment,
		);
		return;
	}

	var _a = {
		printText: [
			encodePrintTextWithFallback(text),
			horizontal,
			vertical,
			bold,
			invert,
			underline,
			fonttype,
			alignment,
		],
	};
	pos_func['func' + incPosNum] = _a;
	incPosNum++;
}

function print1DBarcode(
	data,
	symbol,
	barWidth,
	height,
	hriPosition,
	alignment,
) {
	var _a = {
		print1DBarcode: [data, symbol, barWidth, height, hriPosition, alignment],
	};
	pos_func['func' + incPosNum] = _a;
	incPosNum++;
}

function printPDF417(
	data,
	symbol,
	alignment,
	columnNumber,
	rowNumber,
	moduleWidth,
	moduleHeight,
	eccLevel,
) {
	var _a = {
		printPDF417: [
			data,
			symbol,
			alignment,
			columnNumber,
			rowNumber,
			moduleWidth,
			moduleHeight,
			eccLevel,
		],
	};
	pos_func['func' + incPosNum] = _a;
	incPosNum++;
}

function printQRCode(data, model, alignment, moduleSize, eccLevel) {
	var _a = { printQRCode: [data, model, alignment, moduleSize, eccLevel] };
	pos_func['func' + incPosNum] = _a;
	incPosNum++;
}

function printGS1Databar(data, symbol, alignment, moduleSize) {
	var _a = { printGS1Databar: [data, symbol, alignment, moduleSize] };
	pos_func['func' + incPosNum] = _a;
	incPosNum++;
}

function printDataMatrix(data, alignment, moduleSize) {
	var _a = { printDataMatrix: [data, alignment, moduleSize] };
	pos_func['func' + incPosNum] = _a;
	incPosNum++;
}

function printCompositeBarcode(data, symbol, alignment, moduleSize) {
	var _a = { printCompositeBarcode: [data, symbol, alignment, moduleSize] };
	pos_func['func' + incPosNum] = _a;
	incPosNum++;
}

function printBitmap(imagedata, width, alignment, dither) {
	var _a = { printBitmap: [imagedata, width, alignment, dither] };
	pos_func['func' + incPosNum] = _a;
	incPosNum++;
}

function printBitmapFile(filepath, width, alignment, dither) {
	var _a = { printBitmapFile: [filepath, width, alignment, dither] };
	pos_func['func' + incPosNum] = _a;
	incPosNum++;
}

function printPDFFile(filepath, pageNumber, width, alignment, dither) {
	var _a = { printPDFFile: [filepath, pageNumber, width, alignment, dither] };
	pos_func['func' + incPosNum] = _a;
	incPosNum++;
}

function pagemodeBegin() {
	var _a = { pagemodeBegin: [] };
	pos_func['func' + incPosNum] = _a;
	incPosNum++;
}

function pagemodePrintArea(width, height) {
	var _a = { pagemodePrintArea: [width, height] };
	pos_func['func' + incPosNum] = _a;
	incPosNum++;
}

function pagemodePrintPosition(x, y) {
	var _a = { pagemodePrintPosition: [x, y] };
	pos_func['func' + incPosNum] = _a;
	incPosNum++;
}

function pagemodePrintDirection(direction) {
	var _a = { pagemodePrintDirection: [direction] };
	pos_func['func' + incPosNum] = _a;
	incPosNum++;
}

function pagemodeEnd() {
	var _a = { pagemodeEnd: [] };
	pos_func['func' + incPosNum] = _a;
	incPosNum++;
}

function openDrawer(pinNumber) {
	var _a = { openDrawer: [pinNumber] };
	pos_func['func' + incPosNum] = _a;
	incPosNum++;
}

module.exports = {
	getPosData,
	setPosId,
	checkPrinterStatus,
	directPrintText,
	directPrintHex,
	cutPaper,
	setInternationalCharset,
	setCharacterset,
	printText,
	print1DBarcode,
	printPDF417,
	printQRCode,
	printGS1Databar,
	printDataMatrix,
	printCompositeBarcode,
	printBitmap,
	printBitmapFile,
	printPDFFile,
	pagemodeBegin,
	pagemodePrintArea,
	pagemodePrintPosition,
	pagemodePrintDirection,
	pagemodeEnd,
	openDrawer,
};
